import { render, staticRenderFns } from "./EiGoodsItem.vue?vue&type=template&id=209db338&scoped=true&"
import script from "./EiGoodsItem.vue?vue&type=script&lang=js&"
export * from "./EiGoodsItem.vue?vue&type=script&lang=js&"
import style0 from "./EiGoodsItem.vue?vue&type=style&index=0&id=209db338&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "209db338",
  null
  
)

export default component.exports